//----------------------
// <auto-generated>
//     Split from WebApiController.ts
//     Regenerate with: node scripts/splitWebApiController.js
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming


import { PosClientBase, PosClientConfig, throwException } from './base';
import type { DeliveryTypeTicketTypeMapping, Ticket, TicketGroupMergeInput } from './types';


export interface ITicketClient {

    getAllDeliveryTypeTicketTypeMappings(): Promise<DeliveryTypeTicketTypeMapping[]>;

    mergeTicketGroupsForPurchaseOrderId(purchaseOrderId: number, input: TicketGroupMergeInput, isManual: boolean | undefined): Promise<boolean>;
}

export class TicketClient extends PosClientBase implements ITicketClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAllDeliveryTypeTicketTypeMappings(signal?: AbortSignal | undefined): Promise<DeliveryTypeTicketTypeMapping[]> {
        let url_ = this.baseUrl + "/api/Ticket/GetAllDeliveryTypeTicketTypeMappings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllDeliveryTypeTicketTypeMappings(_response);
        });
    }

    protected processGetAllDeliveryTypeTicketTypeMappings(response: Response): Promise<DeliveryTypeTicketTypeMapping[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeliveryTypeTicketTypeMapping[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeliveryTypeTicketTypeMapping[]>(null as any);
    }

    mergeTicketGroupsForPurchaseOrderId(purchaseOrderId: number, input: TicketGroupMergeInput, isManual: boolean | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Ticket/MergeTicketGroupsForPurchaseOrderId/{purchaseOrderId}?";
        if (purchaseOrderId === undefined || purchaseOrderId === null)
            throw new Error("The parameter 'purchaseOrderId' must be defined.");
        url_ = url_.replace("{purchaseOrderId}", encodeURIComponent("" + purchaseOrderId));
        if (isManual === null)
            throw new Error("The parameter 'isManual' cannot be null.");
        else if (isManual !== undefined)
            url_ += "isManual=" + encodeURIComponent("" + isManual) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeTicketGroupsForPurchaseOrderId(_response);
        });
    }

    protected processMergeTicketGroupsForPurchaseOrderId(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}
